import PropTypes from 'prop-types';

export const tabsShape = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string,
    hidden: PropTypes.bool,
    icon: PropTypes.element,
    iconName: PropTypes.string,
    tooltipText: PropTypes.string,
};
